"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var self = {
  spkiToPEM: function spkiToPEM(keydata) {
    var keydataS = self.arrayBufferToString(keydata);
    var keydataB64 = window.btoa(keydataS);
    var keydataB64Pem = self.formatAsPem(keydataB64);
    return keydataB64Pem;
  },
  arrayBufferToString: function arrayBufferToString(buffer) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return binary;
  },
  formatAsPem: function formatAsPem(str) {
    var finalString = '-----BEGIN PUBLIC KEY-----\n';
    while (str.length > 0) {
      finalString += str.substring(0, 64) + '\n';
      str = str.substring(64);
    }
    finalString = finalString + "-----END PUBLIC KEY-----";
    return finalString;
  },
  getRandomString: function getRandomString(length) {
    var randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
    var result = '';
    for (var i = 0; i < length; i++) {
      result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    return result;
  },
  removeLines: function removeLines(str) {
    return str.replace("\n", "");
  },
  base64ToArrayBuffer: function base64ToArrayBuffer(b64) {
    var byteString = window.atob(b64);
    var byteArray = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      byteArray[i] = byteString.charCodeAt(i);
    }
    return byteArray;
  },
  ab2str: function ab2str(buf) {
    return String.fromCharCode.apply(null, new Uint8Array(buf));
  },
  pemToArrayBuffer: function pemToArrayBuffer(pem, type) {
    if (!type) {
      type = 'public';
    }
    var b64Lines = self.removeLines(pem);
    var b64Prefix, b64Final;
    if (type === 'public') {
      b64Prefix = b64Lines.replace('-----BEGIN PUBLIC KEY-----', '');
      b64Final = b64Prefix.replace('-----END PUBLIC KEY-----', '');
    } else {
      b64Prefix = b64Lines.replace('-----BEGIN PRIVATE KEY-----', '');
      b64Final = b64Prefix.replace('-----END PRIVATE KEY-----', '');
    }
    return self.base64ToArrayBuffer(b64Final);
  },
  str2ab: function str2ab(str) {
    var buf = new ArrayBuffer(str.length);
    var bufView = new Uint8Array(buf);
    for (var i = 0, strLen = str.length; i < strLen; i++) {
      bufView[i] = str.charCodeAt(i);
    }
    return buf;
  }
};
var _default = exports["default"] = self;